import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfigResponseData, GetImportState } from '../../actions/types/services/ImportAllServiceSummaryTypes';

/**
 * Initial Event state in store
 */
const initialState: GetImportState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  errorCode: '',
  config: {
    correlationId: '',
    totalRecordsCount: 0,
    totalSuccessRecordsCount: 0,
    totalFailureRecordsCount: 0,
    sourceEnv: '',
    createdBy: '',
    createdTimestamp: '',
    records: []
  }
};

/**
 * Create Event Slice to create new Event
 */
const ImportServiceSummarySlice = createSlice({
  name: 'ImportServiceSummarys',
  initialState,
  reducers: {
    ImportServiceSummaryStarted: (state) => {
      state.isLoading = true;
    },

    ImportServiceSummarySuccess: (state, action: PayloadAction<ConfigResponseData>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.config = action.payload;
    },

    ImportServiceSummaryFail: (state, action: PayloadAction<{ errorCode: string, errorMessage: string }>) => {
      state.isLoading = false;
      state.success = false;
      state.errorCode = action.payload.errorCode;
      state.errorMessage = action.payload.errorMessage;
    },

    clearImportServiceSummary: (state,) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.config = initialState.config;
    }
  }
});

export const { ImportServiceSummaryStarted, ImportServiceSummarySuccess, ImportServiceSummaryFail, clearImportServiceSummary } = ImportServiceSummarySlice.actions;
export default ImportServiceSummarySlice.reducer;
